import { Sachverhalt } from '@models/dossier/dossier-models';
import { IServerValidationErrors } from 'app/core/services/validation/models/IServerValidationErrors';

export interface ISachverhaltState {
  sachverhalt: Sachverhalt;
  serverValidationErrors: IServerValidationErrors;
  isSachverhaltLoading: boolean;
  sachverhaltEdit: {
    sachverhaltId: any;
    erfassungSachverhaltId: any;
  };
  triggerElement?: HTMLElement;
}

export const initialState: ISachverhaltState = {
  sachverhalt: null,
  serverValidationErrors: { invalidFields: [], summary: [] },
  isSachverhaltLoading: true,
  sachverhaltEdit: {
    sachverhaltId: null,
    erfassungSachverhaltId: null,
  },
  triggerElement: null,
};
